export default __webpack_public_path__ + "static/results-dark-e35471749d2e254651db4b77d9329026.png";